import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import PartnerReferrals from './tabs/referrals/PartnerReferrals';
import CarrierLookup from './tabs/carrier-lookup/CarrierLookup';
import { Entity } from '../../../types/apiTypes';
import PartnerOnlyRoute from './PartnerOnlyRoute';
import PartnerAgentsHome from './tabs/agents/AgentsHome';

interface PartnerDashboardProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
  showSideNav: boolean;
  setShowSideNav: (show: boolean) => void;
}

function PartnerDashboard({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
  showSideNav,
  setShowSideNav,
}: PartnerDashboardProps) {
  const [currSubPage, setCurrSubPage] = useState<string | null>(null);
  const handleSetSubPage = (page: string | null) => {
    setCurrSubPage(page);
  };
  const commonProps = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
    currSubPage,
    setCurrSubPage: handleSetSubPage,
  };

  return (
    <Routes>
      <Route path="/" element={<PartnerReferrals {...commonProps} />} />
      <Route path="/home/*" element={<PartnerReferrals {...commonProps} />} />
      <Route
        path="referrals/*"
        element={<PartnerReferrals {...commonProps} />}
      />
      <Route
        path="carrier-lookup/*"
        element={<CarrierLookup {...commonProps} />}
      />

      <Route
        path="agents/*"
        element={
          <PartnerOnlyRoute
            userType={userType}
            allowedUserTypes={[Entity.Partner]} // Specify allowed user types here
            element={<PartnerAgentsHome {...commonProps} />}
            redirectPath="/referrals"
          />
        }
      />
    </Routes>
  );
}

export default PartnerDashboard;
